import axios from "axios"
import { call, put, select } from "redux-saga/effects"
import slice from "../slice/user"
import { toast } from "react-toastify"
import { appActions } from "redux/app/slice/app"
import { saveAs } from "file-saver"
import { superAdminAction } from "redux/superAdmin/slice/user"

const baseUrl = process.env.REACT_APP_API_MY_URL

export function* createWineClubMemberships(action) {
  try {
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/wine-club-benefits/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setIsWineClubMembershipSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* uploadBenefitsImage(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload.data)
    if (data.success) {
      toast.success("Image Uploaded", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(
        slice.actions.setbenefitImage({
          index: action.payload.index,
          id: data.data.id
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadMembershipImage(action) {
  try {
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      toast.success("Image Uploaded", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(slice.actions.setMembershipImage(data.data.id))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getExistingBenefits(action) {
  try {
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/wine-club-benefits/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setExistingBenefits(data?.data?.benefits ?? []))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getTriviaCategories(action) {
  try {
    const { data } = yield call(axios.get, `${baseUrl}/trivia/categories/?web=true`, action.payload)
    if (data.success) {
      yield put(slice.actions.setTriviaCategoriesList(data?.data ?? []))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* uploadTastingNotesWineImage(action) {
  try {
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setTastingNotesWineImage(data.data.id))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* uploadTastingNotesVideoThumbnail(action) {
  try {
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setTastingNotesVideoThumbnail(data.data.id))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* uploadTastingNotesFlavourImage(action) {
  try {
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload.data)
    if (data.success) {
      yield put(
        slice.actions.setTastingNotesFlavourImage({
          index: action.payload.index,
          id: data.data.id
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
}

export function* createTastingNotes(action) {
  try {
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/wine-of-the-week/`,
      action.payload
    )
    if (data.success) {
      toast.success("Tasting Note Uploaded", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(slice.actions.setIsTastingNotesSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* editTastingNotes(action) {
  try {
    const id = yield select((store) => store.dmv.tastingNotes.id)
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/wine-of-the-week/${id}/`,
      action.payload
    )
    if (data.success) {
      toast.success("Tasting Note Updated Successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(slice.actions.setIsTastingNotesSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* deleteBenefit(action) {
  try {
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/frontline/wine-club-benefits/${action.payload}/`
    )
    if (data.success) {
      const existingBenefits = yield select(
        (store) => store.dmv.wineClubMembership.existingBenefits
      )
      yield put(
        slice.actions.setExistingBenefits(existingBenefits.filter((el) => el.id !== action.payload))
      )
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getTastingNotesWeekList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/wine-of-the-week-list-web/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setWeekList(data?.data ?? []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getTastingNotesData(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/wine-of-the-week/${action.payload}/`
    )
    if (data.success) {
      yield put(slice.actions.setTastingNotesData(data?.data ?? {}))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteTastingNote() {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = yield select((store) => store.dmv.tastingNotes)
    const { data } = yield call(axios.delete, `${baseUrl}/frontline/wine-of-the-week/${id}/`)
    if (data.success) {
      const { data } = yield call(axios.get, `${baseUrl}/frontline/wine-of-the-week-list-web/`)
      if (data.success) {
        yield put(slice.actions.setWeekList(data?.data ?? []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* postVIPEmailMapping(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/vip/email/mapping/`, action.payload)
    if (data.success) {
      toast.success(data?.message || "Email mapping saved successfully", {
        position: "bottom-left"
      })
    }
  } catch (e) {
    console.log(e)
    toast.error(e?.response?.data?.message || "Failed to save email mapping", {
      position: "bottom-left"
    })
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* uploadTriviaCategoryImage(action) {
  try {
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload.data)
    if (data.success) {
      toast.success("Image Uploaded", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(
        slice.actions.setTriviaCategoryImage({
          index: action.payload.index,
          id: data.data.id
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
}

export function* createTriviaCategories(action) {
  try {
    const { data } = yield call(axios.post, `${baseUrl}/trivia/categories/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setIsTriviaCategoriesSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* updateTriviaCategories(action) {
  try {
    const { data } = yield call(axios.patch, `${baseUrl}/trivia/categories/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setIsTriviaCategoriesSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getWineBenefitData(action) {
  try {
    const id = yield select((store) => store.dmv.wineBenefits.id)
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/wine-club-benefits/${id}/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setWineBenefitData(data?.data ?? {}))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* uploadBenefitIconImage(action) {
  try {
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      toast.success("Image Uploaded", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(slice.actions.setBenefitImageIcon(data.data.id))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* editWineBenefits(action) {
  try {
    const id = yield select((store) => store.dmv.wineBenefits.id)
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/wine-club-benefits/${id}/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setIsBenefitSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getMembershipImageURL(action) {
  try {
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/wine-club-membership/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setMembershipImageURL(data?.data?.[0]?.image))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* uploadGrandCruThumbnail(action) {
  try {
    yield put(slice.actions.setGrandCruLoadingStart(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      toast.success("Image Uploaded", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(slice.actions.setGrandCruThumbnail(data.data.id))
    }
  } catch (e) {
    console.log(e)
  } finally {
    yield put(slice.actions.setGrandCruLoadingEnd(false))
  }
}

export function* uploadGrandCruVideo(action) {
  try {
    yield put(slice.actions.setGrandCruLoadingStart(true))
    const id = toast.loading("Uploading Video", {
      position: "bottom-left",
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      theme: "dark"
    })
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      toast.update(id, {
        render: "Video Uploaded",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        progress: undefined
      })
      yield put(slice.actions.setGrandCruVideo(data.data.id))
    }
  } catch (e) {
    console.log(e)
  } finally {
    yield put(slice.actions.setGrandCruLoadingEnd(false))
  }
}

export function* getGrandCruGoals(action) {
  try {
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/grand-cru-settings/`,
      action.payload
    )
    if (data.success) {
      yield put(
        slice.actions.setGrandCruGoalsData({
          id: data?.data?.id || "",
          server: data?.data?.server_goal || 0,
          bartender: data?.data?.bartender_goal || 0,
          tr: data?.data?.tasting_room_attendant_goal || 0
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
}

export function* updateGrandCruGoals(action) {
  try {
    const { data } = yield call(
      action.payload.id ? axios.patch : axios.post,
      `${baseUrl}/frontline/grand-cru-settings/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setGrandCruGoalsSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getGrandCruVideoData(action) {
  try {
    const { data } = yield call(axios.get, `${baseUrl}/frontline/grand-cru-video/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setGrandCruVideoData(data?.data?.[0] || {}))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* updateGrandCruVideo(action) {
  try {
    const { id } = action.payload
    const { data } = yield call(
      id ? axios.patch : axios.post,
      `${baseUrl}/frontline/grand-cru-video/${id ? `${id}/` : ""}`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setGrandCruVideoSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* uploadVideoGalleryThumbnail(action) {
  try {
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      toast.success("Thumbnail Uploaded", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(slice.actions.setVideoGalleryThumbnail(data.data.id))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* uploadVideoGalleryVideo(action) {
  try {
    const { payload, isEditMode } = action.payload
    const id = yield select((store) => store.dmv.videoGallery.id)
    const { data } = yield call(
      isEditMode ? axios.patch : axios.post,
      `${baseUrl}/frontline/performance-management-video/${isEditMode ? `${id}/` : ""}`,
      payload
    )
    if (data.success) {
      yield put(slice.actions.setVideoGalleryVideoSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getVideoGalleryVideos(action) {
  try {
    let params = ""
    if (action.payload === "assigned") {
      params = "?assigned=True"
    } else if (action.payload === "unassigned") {
      params = "?assigned=False"
    }
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/performance-management-video/${params}`
    )
    if (data.success) {
      yield put(
        slice.actions.setVideoGalleryVideosList({
          type: action.payload,
          data: data.data || []
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
}

export function* deleteVideoGalleryVideo() {
  try {
    const id = yield select((store) => store.dmv.videoGallery.id)
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/frontline/performance-management-video/${id}/`
    )
    if (data.success) {
      yield put(slice.actions.setVideoGalleryVideoDeleted(true))
      toast.success("Video Deleted", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getRoundsList() {
  try {
    const { data } = yield call(axios.get, `${baseUrl}/frontline/round-configuration/`)
    if (data.success) {
      yield put(slice.actions.setRoundsList(data.data))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getViewRoundData(action) {
  try {
    const id = yield select((store) => store.dmv.rounds.roundId)
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/round-configuration/${id}/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setViewRoundData(data?.data ?? {}))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* createRound(action) {
  try {
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/round-configuration/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setRoundId(data?.data?.id))
      yield put(slice.actions.setFromRoundId(data?.data?.id))
      yield put(slice.actions.setIsRoundFormSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* deleteRound() {
  try {
    const id = yield select((store) => store.dmv.rounds.roundId)
    yield call(axios.delete, `${baseUrl}/frontline/round-configuration/${id}/`)
    const { data } = yield call(axios.get, `${baseUrl}/frontline/round-configuration/`)
    if (data.success) {
      yield put(slice.actions.setRoundsList(data.data))
      toast.success("Round Deleted", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getRoundData() {
  try {
    const id = yield select((store) => store?.dmv?.roundForm?.id)
    const { data } = yield call(axios.get, `${baseUrl}/frontline/round-configuration/${id}/`)
    if (data.success) {
      yield put(slice.actions.setRoundFormData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* updateRound(action) {
  try {
    const id = yield select((store) => store?.dmv?.roundForm?.id)
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/round-configuration/${id}/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setIsRoundFormSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getHolidays(action) {
  try {
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/holiday-calendar/?date=${action.payload}`
    )
    if (data.success) {
      yield put(
        slice.actions.setHolidayCalendarData({
          date: action.payload,
          data: data.data
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getVideoLibraryVideos(action) {
  try {
    yield put(slice.actions.setAssignVideosLoading(true))
    let query = `page=${action.payload.page}`
    if (action?.payload?.filter !== "all-videos") {
      query += `&video-type=${action.payload.filter}`
    }
    if (action?.payload?.searchData) {
      query += `&search=${action.payload.searchData}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/frontline/video-library?${query}`)
    if (data.success) {
      yield put(slice.actions.setVideoLibrary(data?.data?.results || 0))
      yield put(slice.actions.setAssignVideoTotalPages(data?.data?.pages || 0))
      yield put(slice.actions.setAssignVideosLoading(false))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getAssignVideosWeekData(action) {
  try {
    const id = yield select((store) => store?.dmv?.roundForm?.id)
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/round-configuration/${id}/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setAssignVideosWeekData(data?.data?.weeks || []))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* assignVideos(action) {
  try {
    const id = yield select((store) => store?.dmv?.roundForm?.id)
    const { data } = yield call(axios.post, `${baseUrl}/frontline/round-video-assigment`, {
      round: id,
      video_data: action.payload
    })
    if (data.success) {
      yield put(slice.actions.setAssignVideosSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* roundStatusUpdate(action) {
  try {
    const id = yield select((store) => store?.dmv?.roundForm?.id)
    yield call(
      axios.post,
      `${baseUrl}/frontline/round-configuration/${id}/publish/`,
      action.payload
    )
  } catch (e) {
    console.log(e)
  }
}

export function* uploadHolidayList(action) {
  console.log(action.payload)
  try {
    const headerParams = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }

    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/upload-holidays`,
      {
        file: action.payload
      },
      headerParams
    )

    if (data.success) {
      toast.success("Upload Successful", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getImportPreviousRounds(action) {
  const { import_tasting, import_n_tasting } = action.payload
  const id = yield select((store) => store?.dmv?.roundForm?.id)

  try {
    if (import_tasting === null && import_n_tasting === null) {
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/round-configuration/${id}/`,
        action.payload
      )
      if (data.success) {
        yield put(slice.actions.setAssignVideosWeekData(data?.data?.weeks || []))
      }
    } else {
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/import-video/${id}/?import_tasting=${import_tasting}&import_n_tasting=${import_n_tasting}`,
        action.payload
      )
      if (data.success) {
        yield put(slice.actions.setAssignVideosWeekData(data?.data?.weeks || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getDMVWineRegionList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/wine-region-web/?country=${action.payload}`
    )
    if (data.success) {
      yield put(slice.actions.setWineRegionData(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getBeverage() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/beverage-item-web/`)
    if (data.success) {
      yield put(slice.actions.setBeverageData(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getGenerateQuestionDMVWineRegion(action) {
  try {
    const { search } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/wine-region-web/${search !== "" ? `?search=${search}` : ""}`
    )
    if (data.success) {
      yield put(slice.actions.setWineRegionData(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getGenerateQuestionDMVBeverage(action) {
  try {
    const { search } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/beverage-item-web/${search !== "" ? `?search=${search}` : ""}`
    )
    if (data.success) {
      yield put(slice.actions.setBeverageData(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editWineRegionCategory(action) {
  const { categoryID, name, wine_country } = action.payload
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/wine-region-category/${categoryID}`,
      {
        name: name,
        wine_country: wine_country
      }
    )
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/wine-region-web/?country=${wine_country}`
      )
      if (newData.success) {
        yield put(slice.actions.setWineRegionData(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addWineRegionCategory(action) {
  const { name, wine_country } = action.payload
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/wine-region-category/`, {
      name: name,
      wine_country: wine_country
    })
    if (data.success) {
      yield put(slice.actions.setDMVMenuCategoryId(data.data.id))
      const { dmvMenuCategory } = yield select((store) => store.dmv)
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/wine-region-web/?country=${dmvMenuCategory?.category}`
      )
      if (newData.success) {
        yield put(slice.actions.setWineRegionData(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteWineRegionMenuCategory(action) {
  const { categoryID } = action.payload
  try {
    yield put(appActions.setIsLoading(true))
    yield call(axios.delete, `${baseUrl}/frontline/wine-region-category/${categoryID}`)
    const { dmvMenuCategory } = yield select((store) => store.dmv)
    const { data: newData } = yield call(
      axios.get,
      `${baseUrl}/frontline/wine-region-web/?country=${dmvMenuCategory?.category}`
    )
    if (newData.success) {
      yield put(slice.actions.setWineRegionData(newData?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addDMVWineMenuItems(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { dmvMenuCategory } = yield select((store) => store.dmv)
    const { data } = yield call(axios.post, `${baseUrl}/frontline/wine-region/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setDMVMenuCategoryId(data.data.id))
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/wine-region-web/?country=${dmvMenuCategory?.category}`
      )
      if (newData.success) {
        yield put(slice.actions.setWineRegionData(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getDMVWineItems() {
  const { itemID } = yield select((store) => store.dmv)
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/wine-region/${itemID ?? ""}`)
    if (data.success) {
      yield put(slice.actions.setWineMenuItem(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateDMVWineItems(action) {
  const { itemID } = yield select((store) => store.dmv)
  try {
    yield put(appActions.setIsLoading(true))
    const { dmvMenuCategory } = yield select((store) => store.dmv)
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/wine-region/${itemID ?? ""}`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setDMVMenuCategoryId(data.data.id))
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/wine-region-web/?country=${dmvMenuCategory?.category}`
      )
      if (newData.success) {
        yield put(slice.actions.setWineRegionData(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteDMVWineMenuItem() {
  const { itemID, dmvMenuCategory } = yield select((store) => store.dmv)
  try {
    yield put(appActions.setIsLoading(true))
    yield call(axios.delete, `${baseUrl}/frontline/wine-region/${itemID}`)
    yield put(slice.actions.setDMVMenuCategoryId(""))
    const { data: newData } = yield call(
      axios.get,
      `${baseUrl}/frontline/wine-region-web/?country=${dmvMenuCategory?.category}`
    )
    if (newData.success) {
      yield put(slice.actions.setWineRegionData(newData?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editBeverageCategory(action) {
  const { categoryID, name } = action.payload
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/beverage-category/${categoryID}`,
      {
        name: name
      }
    )
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/beverage-item-web/`)
      if (newData.success) {
        yield put(slice.actions.setBeverageData(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addBeverageCategory(action) {
  const { name } = action.payload
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/beverage-category/`, {
      name: name
    })
    if (data.success) {
      yield put(slice.actions.setDMVMenuCategoryId(data.data.id))
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/beverage-item-web/`)
      if (newData.success) {
        yield put(slice.actions.setBeverageData(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteBeverageCategory(action) {
  const { categoryID } = action.payload
  try {
    yield put(appActions.setIsLoading(true))
    yield call(axios.delete, `${baseUrl}/frontline/beverage-category/${categoryID}`)
    const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/beverage-item-web/`)
    if (newData.success) {
      yield put(slice.actions.setBeverageData(newData?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addDMVBeverageMenuItems(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/beverage/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setDMVMenuCategoryId(data.data.id))
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/beverage-item-web/`)
      if (newData.success) {
        yield put(slice.actions.setBeverageData(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getDMVBeverageItems() {
  const { itemID } = yield select((store) => store.dmv)
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/beverage/${itemID ?? ""}`)
    if (data.success) {
      yield put(slice.actions.setBeverageMenuItem(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateDMVBeverageItems(action) {
  const { itemID } = yield select((store) => store.dmv)
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/beverage/${itemID ?? ""}`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setDMVMenuCategoryId(data.data.id))
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/beverage-item-web/`)
      if (newData.success) {
        yield put(slice.actions.setBeverageData(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteDMVBeverageMenuItem() {
  const { itemID } = yield select((store) => store.dmv)
  try {
    yield put(appActions.setIsLoading(true))
    yield call(axios.delete, `${baseUrl}/frontline/beverage/${itemID}`)
    yield put(slice.actions.setDMVMenuCategoryId(""))
    const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/beverage-item-web/`)
    if (newData.success) {
      yield put(slice.actions.setBeverageData(newData?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getDMVAutoSuggestQuestions(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/trivia/auto-suggested-questions/?platform=GAMIFICATION&page=${action.payload?.page}`
    )
    if (data.success) {
      yield put(slice.actions.setDMVAutoSuggestQuestions(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editDMVAutoSuggestedQuestion(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/trivia/intermediate-questions/${action.payload.questionId}`,
      action.payload.data
    )
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/trivia/auto-suggested-questions/?platform=GAMIFICATION&page=${action.payload.currentPage}`
      )
      if (newData.success) {
        yield put(slice.actions.setDMVAutoSuggestQuestions(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}
export function* getQuizCategory() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/platform/quiz/categories`)
    if (data.success) {
      yield put(slice.actions.setQuizCategory(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}
export function* createQuiz(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, handleRoute } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/frontline/platform/quiz/`, payload)
    if (data.success) {
      handleRoute()
      yield put(slice.actions.setQuizId(data?.data?.quiz_id || ""))
      yield put(slice.actions.setQuizQuestionBank(data?.data || {}))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editQuiz(action) {
  try {
    const { quizId } = yield select((store) => store?.dmv)
    yield put(appActions.setIsLoading(true))
    const { payload, type, handleRoute } = action.payload
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/platform/quiz/${quizId}`,
      payload
    )
    if (data.success) {
      handleRoute()
      if (type != "edit") {
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/platform/quiz/${quizId}/questions`
        )
        if (newData.success) {
          yield put(slice.actions.setQuizQuestionBank(newData?.data || {}))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteQuiz(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/frontline/platform/quiz/${action.payload}`
    )
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/platform/quiz/`)
      if (newData.success) {
        yield put(slice.actions.setDmvQuizList(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getDmvQuizList() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/platform/quiz/`)
    if (data.success) {
      yield put(slice.actions.setDmvQuizList(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addQuestionToQuiz(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { quizId } = yield select((store) => store.dmv)
    const { payload, handleRoute } = action.payload
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/platform/quiz/${quizId}/questions`,
      payload
    )
    if (data.success) {
      handleRoute()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteQuestionFromQuiz(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { quizId } = yield select((store) => store.dmv)
    const { id } = action.payload
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/frontline/platform/quiz/${quizId}/questions/${id}`
    )
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/platform/quiz/${quizId}`
      )
      if (newData.success) {
        yield put(slice.actions.setQuizData(newData?.data || {}))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getQuizData(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/platform/quiz/${action.payload}`)
    if (data.success) {
      yield put(slice.actions.setQuizData(data?.data || {}))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getQuizQuestionsList() {
  try {
    yield put(appActions.setIsLoading(true))
    const { quizId } = yield select((store) => store.dmv)
    const { data } = yield call(axios.get, `${baseUrl}/frontline/platform/quiz/${quizId}/questions`)
    if (data.success) {
      yield put(slice.actions.setQuizQuestionsList(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* editSpiritCategory(action) {
  const { categoryID, name } = action.payload
  try {
    const { menuCategory } = yield select((store) => store.dmv)
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.patch, `${baseUrl}/frontline/spirit-category/${categoryID}`, {
      name: name
    })
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?console=dmv`
      )
      if (newData.success) {
        yield put(slice.actions.setSpiritData(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addSpiritCategory(action) {
  const { name } = action.payload
  try {
    const { menuCategory } = yield select((store) => store.dmv)
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/spirit-category/`, {
      name: name,
      sub_category: menuCategory?.name
    })
    if (data.success) {
      yield put(slice.actions.setDMVMenuCategoryId(data.data.id))
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?console=dmv`
      )
      if (newData.success) {
        yield put(slice.actions.setSpiritData(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteSpiritCategory(action) {
  const { categoryID } = action.payload
  try {
    const { menuCategory } = yield select((store) => store.dmv)
    yield put(appActions.setIsLoading(true))
    yield call(axios.delete, `${baseUrl}/frontline/spirit-category/${categoryID}`)
    const { data: newData } = yield call(
      axios.get,
      `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?console=dmv`
    )
    if (newData.success) {
      yield put(slice.actions.setSpiritData(newData?.data || []))
    }
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/spirit-sub-category/?platform=dmv&console=dmv`
    )
    if (data.success) {
      yield put(slice.actions.setSpiritSubMenuItems(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getDMVSpiritSubMenuist(action) {
  try {
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/spirit-sub-category/${
        action.payload !== "" && action.payload
          ? `?platform=${action.payload}&console=${action.payload}`
          : ""
      }`
    )
    if (data.success) {
      yield put(slice.actions.setSpiritSubMenuItems(data.data))
      yield put(slice.actions.setSubFilterValue({ name: data.data?.[0]?.id, list: "Summary View" }))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getSpirit(action) {
  try {
    const { menuCategory } = yield select((store) => store.dmv)
    if (menuCategory?.name) {
      yield put(appActions.setIsLoading(true))
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?console=dmv${
          action.payload !== "" && action.payload ? `&search=${action.payload}` : ""
        }`
      )
      if (data.success) {
        yield put(slice.actions.setSpiritData(data?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getDMVSpiritItems() {
  const { itemID } = yield select((store) => store.dmv)
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/spirit-menu/${itemID ?? ""}`)
    if (data.success) {
      yield put(slice.actions.setSpiritMenuItem(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addDMVSpiritMenuItems(action) {
  try {
    const { menuCategory } = yield select((store) => store.dmv)
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/spirit-menu/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setDMVMenuCategoryId(data.data.id))
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?console=dmv`
      )
      if (newData.success) {
        yield put(slice.actions.setSpiritData(newData?.data || []))
      }
      const { data: countData } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-sub-category/?platform=dmv&console=dmv`
      )
      if (countData.success) {
        yield put(slice.actions.setSpiritSubMenuItems(countData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateDMVSpiritItems(action) {
  const { itemID, menuCategory } = yield select((store) => store.dmv)
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/spirit-menu/${itemID ?? ""}`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setDMVMenuCategoryId(data.data.id))
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?console=dmv`
      )
      if (newData.success) {
        yield put(slice.actions.setSpiritData(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteDMVSpiritMenuItem() {
  const { itemID, menuCategory } = yield select((store) => store.dmv)
  try {
    yield put(appActions.setIsLoading(true))
    yield call(axios.delete, `${baseUrl}/frontline/spirit-menu/${itemID}`)
    yield put(slice.actions.setDMVMenuCategoryId(""))
    const { data: newData } = yield call(
      axios.get,
      `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?console=dmv`
    )
    if (newData.success) {
      yield put(slice.actions.setSpiritData(newData?.data || []))
    }
    const { data: countData } = yield call(
      axios.get,
      `${baseUrl}/frontline/spirit-sub-category/?platform=dmv&console=dmv`
    )
    if (countData.success) {
      yield put(slice.actions.setSpiritSubMenuItems(countData.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getGenerateQuestionDMVSpirits(action) {
  try {
    const { search, page } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/spirit-menu/?page=${page}&page_size=5${
        search !== "" ? `&search=${search}` : ""
      }`
    )
    if (data.success) {
      yield put(slice.actions.setSpiritsData(data?.data || {}))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getImportSpirit(action) {
  try {
    const { menuCategory } = yield select((store) => store.dmv)
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?&item_state=available${
        action.payload !== "" && action.payload ? `&search=${action.payload}` : ""
      }`
    )
    if (data.success) {
      yield put(slice.actions.setSpiritData(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addDMVSpiritSubMenuist(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/spirit-sub-category/${action?.payload?.category}`,
      action.payload
    )
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/spirit-sub-category/`)
      if (newData.success) {
        yield put(slice.actions.setSpiritSubMenuItems(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getDMVSpiritSummary(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/spirit-sub-category/${action?.payload}`
    )
    if (data.success) {
      yield put(slice.actions.setSpiritSummary(data?.data || {}))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getMonthlyAnalytics(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const {
      activeTab,
      restaurant,
      period,
      orderBy,
      raffleAccess,
      employeeClass,
      userStatus,
      usersLoginStatus
    } = action.payload
    console.log(raffleAccess, employeeClass, userStatus, usersLoginStatus)

    let params = `?restaurant=${restaurant}&period=${period}&tab=${activeTab}`
    if (orderBy) {
      params += `&order_by=${orderBy}`
    }
    if (raffleAccess) {
      params += `&raffle_access=${raffleAccess}`
    }
    if (employeeClass !== "ALL" && !!employeeClass) {
      let job_class = employeeClass.replace(/&/g, "%26")
      params += `&job_class=${job_class}`
    }
    if (userStatus) {
      params += `&status=${userStatus}`
    }
    if (usersLoginStatus) {
      params += `&user_login_status=${usersLoginStatus}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/frontline/platform/analytics/${params}`)
    if (data.success) {
      yield put(slice.actions.setMontlyAnalytics(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getWeeklyAnalytics(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { restaurant, period, raffleAccess, employeeClass, userStatus, usersLoginStatus } =
      action.payload
    let params = `?restaurant=${restaurant}&period=${period}`
    if (raffleAccess) {
      params += `&raffle_access=${raffleAccess}`
    }

    if (employeeClass !== "ALL" && !!employeeClass) {
      let job_class = employeeClass.replace(/&/g, "%26")
      params += `&job_class=${job_class}`
    }
    if (userStatus) {
      params += `&status=${userStatus}`
    }
    if (usersLoginStatus) {
      params += `&user_login_status=${usersLoginStatus}`
    }
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/platform/trend-analytics/${params}`
    )
    if (data.success) {
      yield put(slice.actions.setWeeklyAnalytics(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getExportData(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { restaurant, period, type, activeTab, onClose, analyticsType } = action.payload
    let params = `${analyticsType}/?export=True&restaurant=${restaurant}&period=${period}&file_type=${type}`
    if (activeTab) {
      params += `&tab=${activeTab}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/frontline/platform/${params}`)
    if (data.success) {
      const { file_url } = data.data

      if (file_url) {
        const [metadata, base64Data] = file_url.split(";base64,")
        const mimeType = metadata.split(":")[1].split(";")[0]
        const fileName = metadata.split("name=")[1] || "exported_file.csv"
        const binaryData = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0))
        const blob = new Blob([binaryData], { type: mimeType })
        saveAs(blob, fileName)
      }

      onClose()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getPushNotification(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { page, orderBy, search, restaurant, employeeClass } = action.payload
    let params = `?page=${page}`
    if (orderBy) {
      params += `&order_by=${orderBy}`
    }
    if (search && search !== "") {
      params += `&search=${search}`
    }
    if (restaurant && restaurant !== "ALL") {
      params += `&restaurant=${restaurant}`
    }
    if (employeeClass && employeeClass !== "ALL") {
      let role = employeeClass.replace(/&/g, "%26")
      params += `&job_class=${role}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/notifications/v1/${params}`)
    if (data.success) {
      yield put(slice.actions.setPushNotification(data?.data || {}))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
  if (action.payload.callback) {
    action.payload.callback()
  }
}

export function* getEmployeeList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const restaurantIds = action.payload
    let params = ""
    if (restaurantIds !== "restaurant_ids=All") {
      params = `?${restaurantIds}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/notifications/user-list/${params}`)
    if (data.success) {
      yield put(slice.actions.setEmployeeList(data?.data?.users || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addPushNotification(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/notifications/v1/`, action.payload)
    if (data.success) {
      let params = `page=1`
      const { data: newData } = yield call(axios.get, `${baseUrl}/notifications/v1/?${params}`)
      if (newData.success) {
        yield put(slice.actions.setPushNotification(newData?.data || {}))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* resendNotification(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/notifications/trigger-v1/`, action.payload)
    if (data.success) {
      let params = `page=1`
      const { data: newData } = yield call(axios.get, `${baseUrl}/notifications/v1/?${params}`)
      if (newData.success) {
        yield put(slice.actions.setPushNotification(newData?.data || {}))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getVIPRestaurants() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/vip/restaurants-vip/?restaurant=3e01ef87-42f3-42f5-8a50-9556a459d8e9`
    )
    if (data.success) {
      yield put(slice.actions.setVIPRestaurantsList(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getVIPList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, handleRoute } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/vip/guest-vip/?restaurant=${id}`)
    if (data.success) {
      yield put(slice.actions.setVIPList(data?.data))
      handleRoute && handleRoute()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getVIPProfile(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, ` ${baseUrl}/vip/generate-vip/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setVIPProfileList(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getVIPImage(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/vip/generated-vip-image/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setVIPImageData(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getRegenerateImage(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { VIPImageData } = yield select((store) => store.dmv)
    const { data } = yield call(axios.post, `${baseUrl}/vip/regenerated-vip-image/`, action.payload)

    if (data.success) {
      toast.success("Images regenerated successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      const generatedData = data?.data
      const updatedVIPImageData = VIPImageData.map((item) => {
        const regeneratedItem = generatedData.find((regen) => regen.id === item.id)
        return regeneratedItem ? regeneratedItem : item
      })

      yield put(slice.actions.setVIPImageData(updatedVIPImageData))
    }
  } catch (e) {
    console.error(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* confirmVIPImage(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.patch, `${baseUrl}/vip/generated-vip-image/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setVIPImageData(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* generateVIPQuestion(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/vip/generate-question/`, action.payload)
    if (data.success) {
      toast.success("Questions Generated successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(slice.actions.setGeneratedVIPQuestions(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getVIPQuestion(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { page, category } = action.payload
    let params = `?page=${page}`
    if (category && category != "all") {
      params += `&restaurant=${category}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/vip/question-bank/${params}`)
    if (data.success) {
      yield put(slice.actions.setVIPQuestionBank(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addToVIPQuestionsBank(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, handleRoute } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/vip/transfer-question/`, payload)
    if (data.success) {
      handleRoute()
      yield put(slice.actions.setGeneratedVIPQuestions([]))
      if (data.success) {
        if (!data.data.message) {
          toast.success(data?.data?.message ?? "Added to question bank", {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "dark"
          })
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editVIPQuestions(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { isRankUpdate } = action.payload
    const { VIPRestaurant } = yield select((store) => store?.dmv)
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/weekly/questions-v2/${action.payload.questionId}/`,
      action.payload.data
    )
    if (data.success) {
      let params = `?page=1`
      if (VIPRestaurant && VIPRestaurant !== "all") {
        params += `&restaurant=${VIPRestaurant}`
      }
      const { data: newData } = yield call(axios.get, `${baseUrl}/vip/question-bank/${params}`)
      if (newData.success) {
        yield put(slice.actions.setVIPQuestionBank(newData?.data))
        toast.success(
          isRankUpdate ? "Question's rank updated successfully" : "Question updated successfully",
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "dark"
          }
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteVIPQuestions(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { question } = action.payload
    const { VIPRestaurant } = yield select((store) => store?.dmv)
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/weekly/questions/${question?.id + `/` ?? ""}`
    )
    if (data.success) {
      let params = `?page=1`
      if (VIPRestaurant && VIPRestaurant !== "all") {
        params += `&restaurant=${VIPRestaurant}`
      }
      const { data: newData } = yield call(axios.get, `${baseUrl}/vip/question-bank/${params}`)
      if (newData.success) {
        yield put(slice.actions.setVIPQuestionBank(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getGenearateQuestionsPrompt() {
  try {
    yield put(appActions.setIsLoading(true))
    const { VIPRestaurant } = yield select((store) => store?.dmv)
    const { data } = yield call(
      axios.get,
      `${baseUrl}/vip/quiz-prompt/?restaurant=${VIPRestaurant}`
    )
    if (data.success) {
      yield put(slice.actions.setPrompt(data?.data?.quiz_prompt))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* UpdatePrompt(action) {
  try {
    yield put(appActions.setIsLoading(true))
    yield call(axios.post, `${baseUrl}/vip/quiz-prompt/`, action.payload)
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getRestaurantsGroupListings() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/user/restaurant-group/`)
    if (data.success) {
      yield put(slice.actions.setRestaurantsGroupListings(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getRestaurantsListings(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/user/restaurant-group/${action.payload}/restaurants/`
    )
    if (data.success) {
      yield put(slice.actions.setRestaurantListings(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createRestaurantGroup(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, handleRoute } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/trivia/group-leaderboard-config/`, payload)
    if (data.success) {
      handleRoute()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getRestaurantsGroup(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { cms } = action.payload
    let params = ""
    if (cms) {
      params = `?cms=true`
    }
    const { data } = yield call(axios.get, `${baseUrl}/trivia/group-leaderboard-config/${params}`)
    if (data.success) {
      yield put(slice.actions.setGroupLeaderBoardData(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteRestaurantsGroup(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/trivia/group-leaderboard-config/${action.payload}/`
    )
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/trivia/group-leaderboard-config/`)
      if (newData.success) {
        yield put(slice.actions.setGroupLeaderBoardData(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getGroupLeaderBoard(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { groupId, date, employeeClass, sort_by, start_date, end_date } = action.payload
    let params = `?role=${employeeClass}&sort_by=${sort_by}`
    if (start_date && end_date) {
      params += `&start_date=${start_date}&end_date=${end_date}`
    } else {
      params += `&month=${date}`
    }
    const { data } = yield call(
      axios.get,
      `${baseUrl}/trivia/group-leaderboard-config/${groupId}/leaderboard/${params}`
    )
    if (data.success) {
      yield put(slice.actions.setGroupLeaderboard(data?.data?.leader_board))
      let roleList = []
      if (Array.isArray(data?.data?.roles) && data?.data?.roles.length > 0) {
        for (let role of data.data.roles) {
          roleList.push({
            value: role,
            label: role
          })
        }
      }
      roleList.unshift({ label: "All", value: "All" })
      yield put(superAdminAction.setUserRole(roleList))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNewGroupLeaderBoard(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { groupId, date, employeeClass, sort_by, start_date, end_date } = action.payload
    let params = `?role=${employeeClass}&sort_by=${sort_by}`
    if (start_date && end_date) {
      params += `&start_date=${start_date}&end_date=${end_date}`
    } else {
      params += `&month=${date}`
    }
    const { data } = yield call(
      axios.get,
      `${baseUrl}/weekly/group-leaderboard-config/${groupId}/leaderboard/${params}`
    )
    if (data.success) {
      yield put(slice.actions.setGroupLeaderboard(data?.data?.leader_board))
      let roleList = []
      if (Array.isArray(data?.data?.roles) && data?.data?.roles.length > 0) {
        for (let role of data.data.roles) {
          roleList.push({
            value: role,
            label: role
          })
        }
      }
      roleList.unshift({ label: "All", value: "All" })
      yield put(superAdminAction.setUserRole(roleList))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* exportLeaderboardData(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { groupId, date, startDate, endDate } = action.payload
    let params = "?export=True"
    if (startDate && endDate) {
      params += `&start_date=${startDate}&end_date=${endDate}`
    } else {
      params += `&month=${date}`
    }
    const { data } = yield call(
      axios.get,
      `${baseUrl}/trivia/group-leaderboard-config/${groupId}/leaderboard/${params}`
    )
    if (data.success) {
      const { file_url } = data.data

      if (file_url) {
        const [metadata, base64Data] = file_url.split(";base64,")
        const mimeType = metadata.split(":")[1].split(";")[0]
        const fileName = metadata.split("name=")[1] || "exported_file.csv"
        const binaryData = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0))
        const blob = new Blob([binaryData], { type: mimeType })
        saveAs(blob, fileName)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* exportNewLeaderboardData(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { groupId, date, startDate, endDate } = action.payload
    let params = "?export=True"
    if (startDate && endDate) {
      params += `&start_date=${startDate}&end_date=${endDate}`
    } else {
      params += `&month=${date}`
    }
    const { data } = yield call(
      axios.get,
      `${baseUrl}/weekly/group-leaderboard-config/${groupId}/leaderboard/${params}`
    )
    if (data.success) {
      const { file_url } = data.data

      if (file_url) {
        const [metadata, base64Data] = file_url.split(";base64,")
        const mimeType = metadata.split(":")[1].split(";")[0]
        const fileName = metadata.split("name=")[1] || "exported_file.csv"
        const binaryData = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0))
        const blob = new Blob([binaryData], { type: mimeType })
        saveAs(blob, fileName)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}
export function* exportVIPQuestionsData(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/vip/export-question-bank/`, payload)

    if (data.success) {
      const { file_url } = data.data

      if (file_url) {
        const [metadata, base64Data] = file_url.split(";base64,")
        const mimeType = metadata.split(":")[1].split(";")[0]
        const fileName = metadata.split("name=")[1] || "exported_file.csv"
        const binaryData = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0))
        const blob = new Blob([binaryData], { type: mimeType })
        saveAs(blob, fileName)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editVIPUser(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { VIPProfileList } = yield select((store) => store.dmv)
    const { vipId, payload } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/vip/generate-vip/${vipId}/`, payload)

    if (data.success) {
      const updatedData = data.data

      const updatedVIPProfileList = VIPProfileList.map((profile) => {
        return {
          ...profile,
          data: profile.data.map((item) =>
            item.id === updatedData.id ? { ...item, ...updatedData } : item
          )
        }
      })

      yield put(slice.actions.setVIPProfileList(updatedVIPProfileList))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getUsageMetics(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const {
      isExport,
      orderBy,
      userType,
      restaurant,
      search,
      startDate,
      endDate,
      raffleAccess,
      employeeClass,
      userStatus,
      usersLoginStatus
    } = action.payload
    let params = `?page=1`
    if (isExport) {
      params += `&export=${isExport}`
    }
    if (orderBy) {
      params += `&sort_by=${orderBy}`
    }
    if (userType !== "All" && !!userType) {
      params += `&filter_by=${userType}`
    }
    if (restaurant !== "ALL" && !!restaurant) {
      params += `&restaurant=${restaurant}`
    }
    if (search && search !== "") {
      params += `&search=${search}`
    }
    if (startDate && endDate) {
      params += `&start_date=${startDate}&end_date=${endDate}`
    }
    if (raffleAccess !== "All" && !!raffleAccess) {
      params += `&raffle_access=${raffleAccess}`
    }
    if (userStatus) {
      params += `&status=${userStatus}`
    }
    if (usersLoginStatus) {
      params += `&users_login_status=${usersLoginStatus}`
    }
    if (employeeClass !== "ALL" && !!employeeClass) {
      let job_class = employeeClass.replace(/&/g, "%26")
      params += `&job_class=${job_class}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/trivia/usage-analytics/${params}`)
    if (data.success) {
      yield put(slice.actions.setUsageMetricsList(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* notifyUser(action) {
  try {
    yield put(appActions.setIsLoading(true))

    const { payload, handleClose } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/trivia/awol/notify/`, payload)

    if (data.success) {
      handleClose()
      toast.success("User Notified", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getUserRoles(action) {
  try {
    const { restaurant } = action.payload
    let params = ""
    if (restaurant && restaurant.length > 0 && !restaurant.includes("ALL")) {
      params = `?restaurant=${Array.isArray(restaurant) ? restaurant.join(",") : restaurant}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/trivia/job-classes/${params}`)
    if (data.success) {
      let roleList = []
      if (data?.data?.job_classes?.length > 0) {
        for (let i of data.data.job_classes) {
          roleList.push({
            value: i,
            label: i
          })
        }
      }
      roleList.unshift({ label: "All", value: "ALL" })
      yield put(superAdminAction.setUserRole(roleList))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* exportUsageMetrics(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { orderBy, userType, restaurant, startDate, endDate, raffleAccess, employeeClass } =
      action.payload
    let params = `?export=True`

    if (orderBy) {
      params += `&sort_by=${orderBy}`
    }
    if (userType !== "all" && !!userType) {
      params += `&filter_by=${userType}`
    }
    if (restaurant !== "ALL" && !!restaurant) {
      params += `&restaurant=${restaurant}`
    }
    if (startDate && endDate) {
      params += `&start_date=${startDate}&end_date=${endDate}`
    }
    if (raffleAccess !== "All" && !!raffleAccess) {
      params += `&raffle_access=${raffleAccess}`
    }
    if (employeeClass !== "ALL" && !!employeeClass) {
      params += `&job_class=${employeeClass}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/trivia/usage-analytics/${params}`)

    if (data.success) {
      const { file_url } = data.data

      if (file_url) {
        const [metadata, base64Data] = file_url.split(";base64,")
        const mimeType = metadata.split(":")[1].split(";")[0]
        const fileName = metadata.split("name=")[1] || "exported_file.csv"
        const binaryData = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0))
        const blob = new Blob([binaryData], { type: mimeType })
        saveAs(blob, fileName)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getMenuCountry() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/wine-region-country/`)
    if (data.success) {
      yield put(slice.actions.setMenuCountry(data?.data?.country_list))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addMenuCountry(action) {
  try {
    const { payload, onClose } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/wine-region-country/`, payload)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/wine-region-country/`)
      if (newData.success) {
        yield put(slice.actions.setMenuCountry(newData?.data?.country_list))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteMenuCountry(action) {
  try {
    const { id, onClose, setSelectedCountry } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.delete, `${baseUrl}/frontline/wine-region-country/${id}/`)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/wine-region-country/`)
      if (newData.success) {
        const promise = yield put(slice.actions.setMenuCountry(newData?.data?.country_list))
        yield promise
        const { menuCountry } = yield select((store) => store.dmv)
        const listItem = {
          item: "wine_region",
          category: menuCountry[0]?.id,
          name: menuCountry[0]?.name
        }
        yield put(slice.actions.setDMVMenuCategory(listItem))
        setSelectedCountry(listItem)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createLeague(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pods/admin/leagues/`, payload)
    if (data.success) {
      yield put(slice.actions.setLeagueId(data?.data?.id))
      yield put(slice.actions.setIsLeagueFormSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createLeagueBulk(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pods/admin/leagues/bulk-create/`, payload)
    if (data.success) {
      yield put(slice.actions.setLeagueId(data?.data?.id))
      yield put(slice.actions.setIsLeagueFormSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getLeagueList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/pods/admin/leagues/`, {
      params: action.payload
    })
    if (data.success) {
      const totalPages = data?.data?.pages || 1
      const paginationData = {
        count: data?.data?.count || 0,
        next: data?.data?.next,
        previous: data?.data?.previous,
        pages: totalPages
      }

      yield put(
        slice.actions.setLeagueList({
          data: data?.data?.results ?? [],
          pagination: paginationData
        })
      )
      yield put(
        slice.actions.setLeaguePagination({
          totalPages,
          currentPage: action.payload?.page || 1
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getLeagueData(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { leagueId } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/pods/admin/leagues/${leagueId}/`)
    if (data.success) {
      yield put(slice.actions.setLeagueData(data?.data ?? {}))
      yield put(slice.actions.setLeagueId(leagueId))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateLeague(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { leagueId, payload } = action.payload
    const { data } = yield call(axios.put, `${baseUrl}/pods/admin/leagues/${leagueId}/`, payload)
    if (data.success) {
      yield put(slice.actions.setIsLeagueFormSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* publishLeague(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { leagueId, onSuccess } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/pods/admin/leagues/${leagueId}/`, {
      status: "running"
    })
    if (data.success) {
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess()
      }
      yield put(slice.actions.setIsLeagueFormSubmitted(true))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadLeaguePrizeImage(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setLeaguePrizeImage(data.data.id))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* moveParticipantToPod(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, onSuccess } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pods/admin/participants/move-pod/`, payload)
    if (data.success) {
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess(data?.data)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getAvailableRestaurants(action) {
  try {
    const { startDate, endDate, leagueId } = action.payload
    let url = `${baseUrl}/pods/admin/leagues/available-restaurants/?start_date=${startDate}&end_date=${endDate}`

    if (leagueId) {
      url += `&league_id=${leagueId}`
    }

    const { data } = yield call(axios.get, url)
    if (data.success) {
      yield put(slice.actions.setAvailableRestaurants(data?.data?.available_restaurants || []))
      yield put(slice.actions.setOccupiedRestaurants(data?.data?.occupied_restaurants || []))
    }
  } catch (e) {
    console.log(e)
    yield put(slice.actions.setAvailableRestaurants([]))
  }
}

export function* markParticipantAsDefaulter(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, onSuccess } = action.payload
    const { data } = yield call(
      axios.post,
      `${baseUrl}/pods/admin/participants/mark-defaulter/`,
      payload
    )
    if (data.success) {
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* renamePod(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { podId, name, onSuccess } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/pods/admin/pods/${podId}/`, { name })
    if (data.success) {
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getEligibleUsersCount(action) {
  try {
    const { restaurant_ids } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pods/admin/leagues/eligible-users-count/`, {
      restaurant_ids
    })
    if (data.success) {
      yield put(slice.actions.setEligibleUsersCount(data?.data?.total_eligible_users || 0))
    }
  } catch (e) {
    console.log(e)
    yield put(slice.actions.setEligibleUsersCount(0))
  }
}

export function* autoGeneratePods(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { leagueId, number_of_pods, onSuccess } = action.payload
    const { data } = yield call(
      axios.post,
      `${baseUrl}/pods/admin/leagues/${leagueId}/auto-generate-pods/`,
      { number_of_pods }
    )
    if (data.success) {
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getAvailableParticipants(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { leagueId } = action.payload
    const { data } = yield call(
      axios.get,
      `${baseUrl}/pods/admin/leagues/${leagueId}/available-members/`
    )
    if (data.success) {
      let availableParticipants = data?.data?.available_users || []
      availableParticipants = availableParticipants.map((participant) => ({
        value: participant.user_id,
        label: participant.full_name
      }))
      yield put(slice.actions.setAvailableParticipants(availableParticipants))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addParticipantToPod(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, onSuccess, podId } = action.payload
    const { data } = yield call(
      axios.post,
      `${baseUrl}/pods/admin/pods/${podId}/add-participant/`,
      payload
    )
    if (data.success) {
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getEngagementAnalytics(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { startDate, endDate, restaurant, tab, page } = action.payload
    let params = `?page=${page}`
    if (tab) {
      params += `&tab=${tab}`
    }
    if (startDate && endDate) {
      params += `&start_date=${startDate}&end_date=${endDate}`
    }
    if (restaurant && restaurant !== "ALL") {
      params += `&restaurant=${restaurant}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/frontline/activity-report/${params}`)
    if (data.success) {
      yield put(slice.actions.setEngagementAnalytics(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* exportEngagementAnalytics(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { startDate, endDate, restaurant, tab } = action.payload
    let params = `?export=true`
    if (tab) {
      params += `&tab=${tab}`
    }
    if (startDate && endDate) {
      params += `&start_date=${startDate}&end_date=${endDate}`
    }
    if (restaurant && restaurant !== "ALL") {
      params += `&restaurant=${restaurant}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/frontline/activity-report/${params}`)
    if (data.success) {
      const { file_data } = data.data

      if (file_data) {
        const [metadata, base64Data] = file_data.split(";base64,")
        const mimeType = metadata.split(":")[1].split(";")[0]
        const fileName = metadata.split("name=")[1] || `engagement_analytics.xlsx`
        const binaryData = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0))
        const blob = new Blob([binaryData], { type: mimeType })
        saveAs(blob, fileName)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getGroupedAnalytics(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const {
      startDate,
      endDate,
      startDate2,
      endDate2,
      metrics,
      restaurant,
      raffleAccess,
      employeeClass,
      userStatus,
      awolDays,
      platformUser,
      usersLoginStatus
    } = action.payload
    let params = `?start_date=${startDate}&end_date=${endDate}`
    if (startDate2 && endDate2) {
      params += `&start_date_2=${startDate2}&end_date_2=${endDate2}`
    }
    if (metrics && metrics.length > 0) {
      params += `&metrics=${metrics.join(",")}`
    }
    if (restaurant && restaurant?.length) {
      params += restaurant?.includes("ALL")
        ? "&restaurant_ids=All"
        : `&restaurant_ids=${restaurant}`
    }
    if (raffleAccess && raffleAccess !== "All") {
      params += `&raffle_access=${raffleAccess}`
    }
    if (employeeClass !== "ALL" && !!employeeClass) {
      let job_class = employeeClass.replace(/&/g, "%26")
      params += `&job_class=${job_class}`
    }
    if (userStatus && userStatus !== "All") {
      params += `&is_active=${userStatus}`
    }
    if (awolDays) {
      params += `&awol_days=${awolDays}`
    }
    if (platformUser && platformUser !== "All") {
      params += `&platform_user=${platformUser}`
    }
    if (usersLoginStatus && usersLoginStatus !== "All") {
      params += `&is_logged_in=${usersLoginStatus}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/frontline/grouped-analytics/${params}`)
    if (data.success) {
      yield put(slice.actions.setGroupedAnalytics(data?.data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* exportGroupedAnalytics(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const {
      startDate,
      endDate,
      startDate2,
      endDate2,
      metrics,
      restaurant,
      raffleAccess,
      employeeClass,
      userStatus,
      awolDays,
      platformUser,
      usersLoginStatus,
      onClose
    } = action.payload
    let params = `?start_date=${startDate}&end_date=${endDate}&export=true`
    if (startDate2 && endDate2) {
      params += `&start_date_2=${startDate2}&end_date_2=${endDate2}`
    }
    if (metrics && metrics.length > 0) {
      params += `&metrics=${metrics.join(",")}`
    }
    if (restaurant) {
      params += restaurant?.includes("ALL")
        ? "&restaurant_ids=All"
        : `&restaurant_ids=${restaurant}`
    }
    if (raffleAccess && raffleAccess !== "All") {
      params += `&raffle_access=${raffleAccess}`
    }
    if (employeeClass !== "All" && !!employeeClass) {
      let job_class = employeeClass.replace(/&/g, "%26")
      params += `&job_class=${job_class}`
    }
    if (userStatus && userStatus !== "All") {
      params += `&is_active=${userStatus}`
    }
    if (awolDays) {
      params += `&awol_days=${awolDays}`
    }
    if (platformUser && platformUser !== "All") {
      params += `&platform_user=${platformUser}`
    }
    if (usersLoginStatus && usersLoginStatus !== "All") {
      params += `&is_logged_in=${usersLoginStatus}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/frontline/grouped-analytics/${params}`)
    if (data) {
      const { file_content, file_name } = data.data

      if (file_content) {
        const [metadata, base64Data] = file_content.split(";base64,")
        const mimeType = metadata.split(":")[1].split(";")[0]
        const fileName = file_name || `grouped_analytics.xlsx`
        const binaryData = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0))
        const blob = new Blob([binaryData], { type: mimeType })
        saveAs(blob, fileName)
      }
      if (onClose) {
        onClose()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}
